import Listagem from '../../componentes/Filiado/Relatorio/Emplacamento/listagem';

function RelatorioEmplacamento() {
  return (
    <Listagem></Listagem>
  );
}

export default RelatorioEmplacamento;
